import api from "./api.js";

export default class ReviewApi {
  static async create(data) {
    return await api.post(`review`, data);
  }
  static async getList(params) {
    return await api.get(`review`, params);
  }
  static async getById(reviewId, params) {
    return await api.get(`review/${reviewId}`, params);
  }
  static async update(reviewId, data) {
    return await api.put(`review/${reviewId}`, data);
  }
  static async delete(reviewId) {
    return await api.del(`review/${reviewId}`);
  }

  static async updateMainFlagTrue(data) {
    return await api.patch(`review/main/state`, data);
  }

  static async updateMainFlagFalse(reviewId, data) {
    return await api.patch(`review/main/state/${reviewId}`, data);
  }
}
